import React from "react";
import Swiper from "swiper";
import style from "./index.module.scss";

import head1 from "@/assets/images/head1.jpg";
import head2 from "@/assets/images/head2.jpg";
import head3 from "@/assets/images/head3.jpg";
import head4 from "@/assets/images/head4.jpg";
import head5 from "@/assets/images/head5.jpg";
// import head6 from "@/assets/images/head6.jpg";

import en_v1 from "@/assets/images/en_v1.jpg";
import en_v2 from "@/assets/images/en_v2.jpg";
import en_v3 from "@/assets/images/en_v3.jpg";
import en_v4 from "@/assets/images/en_v4.jpg";
// import en_v5 from "@/assets/images/en_v5.jpg";
import en_v6 from "@/assets/images/en_v6.jpg";

import akameHead from "@/assets/images/akame_avatar.png";
import dkgamerHame from "@/assets/images/dkgamer_avatar.jpg";
import dramaHead from "@/assets/images/drama_queen_avatar.png";
import dsarcoHead from "@/assets/images/dsarco_avatar.png";
import happyHead from "@/assets/images/happyvp_avatar.jpg";
// import limuluHead from "@/assets/images/limulu_tv.jpg";
import sacrexHead from "@/assets/images/sacrex-avatar.jpg";
// import scottyHead from "@/assets/images/scottykil.jpg";
import oyunHead from "@/assets/images/oyun_militan_avatar.jpg";
import victorHead from "@/assets/images/victor_avatar.png";
import wallabitHead from "@/assets/images/wallabit-avatar.jpg";

import akameHeadVideo from "@/assets/images/akame_cover.jpg";
import dkgamerHameVideo from "@/assets/images/dkgamer_cover.jpg";
import dramaHeadVideo from "@/assets/images/drama_queen_cover.jpg";
import dsarcoHeadVideo from "@/assets/images/dsarco_cover.jpg";
import happyHeadVideo from "@/assets/images/happyvp_thumbnail.jpg";
// import limuluHeadVideo from "@/assets/images/limulutv_thumbnail.jpg";
import sacrexHeadVideo from "@/assets/images/sacrex-cover.jpg";
// import scottyHeadVideo from "@/assets/images/scottykil.png";
import oyunHeadVideo from "@/assets/images/oyun_nilitan_cover.jpg";
import victorHeadVideo from "@/assets/images/victor_cover.png";
import wallabitHeadVideo from "@/assets/images/wallabit_cover.jpg";

// import seaHead1 from "@/assets/images/sea-head1.jpg";
// import seaHead2 from "@/assets/images/sea-head2.jpg";
// import seaHead3 from "@/assets/images/sea-head3.jpg";
// import seaHead4 from "@/assets/images/sea-head4.jpg";
// import seaHead5 from "@/assets/images/sea-head5.jpg";
// import seaHead6 from "@/assets/images/sea-head6.jpg";

// import seaPic1 from "@/assets/images/sea-pic1.jpg";
// import seaPic2 from "@/assets/images/sea-pic2.jpg";
// import seaPic3 from "@/assets/images/sea-pic3.jpg";
// import seaPic4 from "@/assets/images/sea-pic4.jpg";
// import seaPic5 from "@/assets/images/sea-pic5.jpg";
// import seaPic6 from "@/assets/images/sea-pic6.jpg";

import seaHead1 from "@/assets/images/sea_0609_icon1.jpg";
import seaHead2 from "@/assets/images/sea_0609_icon2.jpg";
import seaHead3 from "@/assets/images/sea_0609_icon3.jpg";
import seaHead4 from "@/assets/images/sea_0609_icon4.jpg";

import seaPic1 from "@/assets/images/sea_0609_img1.jpg";
import seaPic2 from "@/assets/images/sea_0609_img2.jpg";
import seaPic3 from "@/assets/images/sea_0609_img3.jpg";
import seaPic4 from "@/assets/images/sea_0609_img4.jpg";

import YouTube from "react-youtube";

import { getDomTop } from "@/common/utils";


const baseCreator = {
  creatorsList: [
    { head: head1, line: "https://www.youtube.com/@artiar-dislyte4093", name: "Artiar" },
    { head: head2, line: "https://www.youtube.com/@DeathwisH-TV", name: "DeathwisH" },
    { head: head3, line: "https://www.youtube.com/@furryhippogaming", name: "Furry Hippo" },
    { head: head4, line: "https://www.youtube.com/@Chisgule", name: "Chisgule" },
    // { head: head6, line: "https://www.youtube.com/@Shinchi42", name: "Shinchi" },
    { head: head5, line: "https://www.youtube.com/@VolkinGames", name: "Volkin" },
  ],
  caseList: [
    { img: en_v1, vid: "M8X13wrhpfw" },
    { img: en_v2, vid: "wvST6Sx0DjI" },
    { img: en_v3, vid: "IH8waq1xNf4" },
    { img: en_v4, vid: "kB6wnJz94d0" },
    // { img: en_v5, vid: "IdttniMb_oQ" },
    { img: en_v6, vid: "_Gog8nDYR6s" }
  ],
};
const multCreator = {
  creatorsList: [
    { head: wallabitHead, line: "https://www.youtube.com/@wallabit", name: "Wallabit" },
    { head: dramaHead, line: "https://www.youtube.com/channel/UCH1SurXM_pqqUPShFWyllwg", name: "Drama Queen" },
    { head: oyunHead, line: "https://www.youtube.com/@OyunMilitani", name: "Oyun Militanı" },
    { head: victorHead, line: "https://www.youtube.com/@VictorAVG", name: "Victor" },
    { head: akameHead, line: "https://www.youtube.com/@cultofdragons", name: "Akame" },
    { head: happyHead, line: "https://www.youtube.com/channel/UCG7dg1UQ2g975wSBA6DTRUA", name: "Happy VP" },
    { head: dkgamerHame, line: "https://www.youtube.com/@dkgamer1983", name: "DKGAMER" },
    { head: dsarcoHead, line: "https://www.youtube.com/@Dsarco", name: "Dsarco" },
    // { head: limuluHead, line: "https://www.youtube.com/channel/UCoFzxeHatJbMNIf9u5Rs8AQ", name: "LimuluTV" },
    { head: sacrexHead, line: "https://www.youtube.com/channel/UCc5V6IbhWHUxMSObRbBupAg", name: "Sacrex" },
    // { head: scottyHead, line: "https://www.youtube.com/channel/UCGu8voueTAz705_KMKwEhxw", name: "Scotty Kil" },
  ],
  caseList: [
    { img: wallabitHeadVideo, vid: "F8JkqIX47qY" },
    { img: dramaHeadVideo, vid: "Pp5EjHGFEfE" },
    { img: oyunHeadVideo, vid: "QZAFn9aRLXY" },
    { img: victorHeadVideo, vid: "4_WDuuY-A9g" },
    { img: akameHeadVideo, vid: "RjlEU7aixyQ" },
    { img: happyHeadVideo, vid: "dljWAj9UcmQ" },
    { img: dkgamerHameVideo, vid: "Y7IYUQSvIHI" },
    { img: dsarcoHeadVideo, vid: "5-GsZUHYNrY" },
    // { img: limuluHeadVideo, vid: "gMSmLhb9wd8" },
    { img: sacrexHeadVideo, vid: "hu4l4cceqpM" },
    // { img: scottyHeadVideo, vid: "7eNUy6V5Xio" },
  ],
};
const seaCreator = {
  creatorsList: [
    { head: seaHead1, line: "https://www.youtube.com/@LOUDLZINN/videos", name: "LOUD LZINN" },
    { head: seaHead2, line: "https://www.youtube.com/@DuckyTheGamer", name: "DuckyTheGamer" },
    { head: seaHead3, line: "https://www.youtube.com/@smithzerax12/videos", name: "SMITH" },
    { head: seaHead4, line: "https://www.youtube.com/@WorryBear", name: "WorryBear" },
  ],
  caseList: [
    { img: seaPic1, vid: "astbxjP2fZQ" },
    { img: seaPic2, vid: "JeGxKPVa8Es" },
    { img: seaPic3, vid: "X1nywe_VczY" },
    { img: seaPic4, vid: "lAyB9NkuSSc" },
  ],
};
const pageLanguage = (navigator.language || navigator.browserLanguage || window.localStorage.getItem("lilacRegion")).toLowerCase();

const multLanguage = ["ar", "pt-br", "pt", "de", "fr", "es", "ru", "tr"];
const seaLanguage = ["vi", "th", "id", "ms", "tl"];

class TierPerks extends React.Component {

  state = {
    tierHeight: 0,
    tierTop: 0,
    active: false,
    swiper: null,
    end: false,

    flexLayout: false,

    creatorsList: [],
    caseList: [],

    youtubeOpts: {
      window: 640,
      height: 390,
      playerVars: {
        autoplay: 1,
      }
    },
    activeYoutube: "",
    reSizeTimeOut: null,

    swiper1ActiveIndex: 0,
    swiper2ActiveIndex: 0,

    loadImg: false
  };

  tierRef = React.createRef();
  tierDetail3 = React.createRef();

  _onReady(event) {
    event.target.pauseVideo();
  }

  componentDidMount() {
    let that = this;
    this.resetSlide();
    if (this.state.reSizeTimeOut) {
      clearInterval(this.state.reSizeTimeOut);
    }
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.resetSlide);
    const reSizeTimeOut = setInterval(this.resetSlide, 300);

    const swiperData = this.checkCreatorData();
    this.setState({
      creatorsList: swiperData.creatorsList,
      caseList: swiperData.caseList
    }, () => {
      const swiper = new Swiper(".example_swiper", {
        observer: true,  //开启动态检查器，监测swiper和slide
        observeParents: true,  //监测Swiper 的祖/父元素
        on: {
          transitionEnd: function () {
            that.setState({
              swiper1ActiveIndex: this.activeIndex
            });
          },
        }
      });
      new Swiper(".star_swiper", {
        observer: true,  //开启动态检查器，监测swiper和slide
        observeParents: true,  //监测Swiper 的祖/父元素
        on: {
          transitionEnd: function () {
            that.setState({
              swiper2ActiveIndex: this.activeIndex
            });
          },
        }
      });
      this.setState({
        swiper
      });
    });
    this.setState({
      detail3Top: getDomTop(this.tierDetail3.current),
      reSizeTimeOut
    });
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.resetSlide);
    if (this.state.reSizeTimeOut) {
      clearInterval(this.state.reSizeTimeOut);
    }
  }

  checkCreatorData() {
    const swiperData1 = { creatorsList: [], caseList: [] };
    if (multLanguage.includes(pageLanguage)) {
      swiperData1.creatorsList = [...multCreator.creatorsList, ...seaCreator.creatorsList, ...baseCreator.creatorsList];
      swiperData1.caseList = [...multCreator.caseList, ...seaCreator.caseList, ...baseCreator.caseList];
    } else if (seaLanguage.includes(pageLanguage)) {
      swiperData1.creatorsList = [...seaCreator.creatorsList, ...baseCreator.creatorsList, ...multCreator.creatorsList];
      swiperData1.caseList = [...seaCreator.caseList, ...baseCreator.caseList, ...multCreator.caseList];
    } else {
      swiperData1.creatorsList = [...baseCreator.creatorsList, ...seaCreator.creatorsList, ...multCreator.creatorsList];
      swiperData1.caseList = [...baseCreator.caseList, ...seaCreator.caseList, ...multCreator.caseList];
    }
    const swiperData2 = { creatorsList: [], caseList: [] };
    while (swiperData1.creatorsList.length > 0) {
      swiperData2.creatorsList.push(swiperData1.creatorsList.splice(0, 6));
      swiperData2.caseList.push(swiperData1.caseList.splice(0, 6));
    }
    return swiperData2;
  }

  resetSlide = () => {
    this.setState({
      tierHeight: this.tierRef.current.clientHeight,
      tierTop: getDomTop(this.tierRef.current),
      detail3Top: getDomTop(this.tierDetail3.current),
      flexLayout: document.documentElement.clientWidth < 1640
    }, () => {
      this.handleScroll();
    });
  };

  handleScroll = () => {
    const wh = document.documentElement.clientHeight;
    const sh = window.document.documentElement.scrollTop;
    const scrollTop = wh + sh;
    if (scrollTop < this.state.tierTop) {
      this.setState({ active: false });
      return;
    }
    if (!this.state.loadImg && sh > 2 * wh) {
      this.setState({ loadImg: true });
    }
    this.setState({ active: true, end: false });
    const scroll_index2 = sh + wh / 4;
    switch (true) {
      case scrollTop > this.state.tierTop + this.state.tierHeight + wh / 3:
        this.props.backToBg();
        this.setState({ end: true });
        break;
      case scroll_index2 > this.state.detail3Top:
        this.props.changeToBg();
        this.setState({ end: false });
        break;
    }
  };

  tier1 = () => (
    <div className={`${style.tier_perks_main} ${this.props.activeBg ? "showAnimate_text_up" : ""}`}>
      <div className={`${style.tier_title}`}>
        <p>{ this.props.langState.homeData.tierTitle }</p>
        <p>{ this.props.langState.homeData.tierDesc }</p>
      </div>
      <div className={style.tier_box}>
        <div className={style.tier1}>
          <div className={style.tier_level_light}></div>
          <div className={`${style.tier1_left}`}></div>
          <div className={`${style.tier1_right}`} ref={this.tierDetail1}>
            <div className={style.tier1_title}></div>
            <ul> { this.props.langState.homeData.tierItem1.map((item, index) => <li key={index}>{item}</li>) } </ul>
          </div>
        </div>
        <div className={style.tier2}>
          <div className={style.tier_level_light}></div>
          <div className={`${style.tier2_left}`}></div>
          <div className={`${style.tier2_right}`}>
            <div className={style.tier2_title}></div>
            <ul> { this.props.langState.homeData.tierItem2.map((item, index) => <li key={index}>{item}</li>) } </ul>
          </div>
        </div>
        <div className={style.tier3}>
          <div className={style.tier_level_light}></div>
          <div className={`${style.tier3_left}`}></div>
          <div className={`${style.tier3_right}`} ref={this.tierDetail3}>
            <div className={style.tier3_title}></div>
            <ul> { this.props.langState.homeData.tierItem3.map((item, index) => <li key={index}>{item}</li>) } </ul>
          </div>
        </div>
      </div>
    </div>
  );

  tierMult = () => (
    <div className={`${style.tier_perks_main} ${this.props.activeBg ? "showAnimate_text_up" : ""}`}>
      <div className={`${style.tier_title}`}>
        <p>{ this.props.langState.homeData.tierMultTitle }</p>
        <p>{ this.props.langState.homeData.tierMultDesc }</p>
      </div>
      <div className={style.tier_box}>
        <div className={style.tier1}>
          <div className={style.tier_level_light}></div>
          <div className={`${style.tier1_left}`}></div>
          <div className={`${style.tier1_right}`} ref={this.tierDetail1}>
            <div className={`${style.tier1_title} ${style.tier1_title_mult}`}></div>
            <ul> { this.props.langState.homeData.tierMultItem1.map((item, index) => <li key={index}>{item}</li>) } </ul>
          </div>
        </div>
        <div className={style.tier2}>
          <div className={style.tier_level_light}></div>
          <div className={`${style.tier2_left}`}></div>
          <div className={`${style.tier2_right}`}>
            <div className={`${style.tier2_title} ${style.tier2_title_mult}`}></div>
            <ul> { this.props.langState.homeData.tierMultItem2.map((item, index) => <li key={index}>{item}</li>) } </ul>
          </div>
        </div>
        <div className={style.tier3}>
          <div className={style.tier_level_light}></div>
          <div className={`${style.tier3_left}`}></div>
          <div className={`${style.tier3_right}`} ref={this.tierDetail3}>
            <div className={`${style.tier3_title} ${style.tier3_title_mult}`}></div>
            <ul> { this.props.langState.homeData.tierMultItem3.map((item, index) => <li key={index}>{item}</li>) } </ul>
          </div>
        </div>
      </div>
    </div>
  );

  render() {
    return (
      <section>
        <div className={`${style.tier_perks_box} ${this.state.end ? style.hide : ""}  ${this.state.flexLayout ? style.flex : ""}`} ref={this.tierRef}>

          <div className={`${style.tier_perks_bg} ${this.props.activeBg ? style.active : ""}`}
            style={{ display: this.props.activeBg ? "block" : "none" }}></div>

          {
            multLanguage.includes(pageLanguage) ? this.tierMult() : this.tier1()
          }

          <div className={`${style.example}`}>
            <div className={style.user_example}>
              <div className="example_swiper swiper">
                <ul className="swiper-wrapper">
                  {
                    this.state.caseList.map((item, index) => (
                      <li className="swiper-slide" key={index}>
                        <div className={style.show_case_box}>
                          <ul>
                            {
                              item.map((subItem) => (
                                <li key={subItem.vid} onClick={() => this.setState({ activeYoutube: subItem.vid })}>
                                  { this.state.loadImg && <img src={subItem.img} /> }
                                </li>)
                              )
                            }
                          </ul>
                        </div>
                      </li>
                    ))
                  }
                </ul>
              </div>
              {
                this.state.caseList.length > 0 && (
                  <div className="example_swiper_pagination swiper-pagination">
                    {
                      this.state.caseList.map((item, index) => (
                        <div className={`swiper-pagination-bullet ${this.state.swiper1ActiveIndex === index ? "swiper-pagination-bullet-active" : ""}`} key={index}></div>
                      ))
                    }
                  </div>
                )
              }
            </div>
            <div className={style.user_star}>
              <div className="star_swiper swiper">
                <div className="swiper-wrapper">
                  {
                    this.state.creatorsList.map((item, index) => (
                      <ul className="swiper-slide" key={index}>
                        {
                          item.map((subItem) => (
                            <li key={subItem.name}>
                              <a href={subItem.line} rel="noopener noreferrer" target="_blank">
                                { this.state.loadImg && <img src={subItem.head} /> }
                              </a>
                              <p>{subItem.name}</p>
                            </li>
                          ))
                        }
                      </ul>
                    ))
                  }
                </div>
              </div>
              {
                this.state.creatorsList.length > 0 && (
                  <div className="example_swiper_pagination swiper-pagination">
                    {
                      this.state.caseList.map((item, index) => (
                        <div className={`swiper-pagination-bullet ${this.state.swiper2ActiveIndex === index ? "swiper-pagination-bullet-active" : ""}`} key={index}></div>
                      ))
                    }
                  </div>
                )
              }
            </div>
          </div>
        </div>
        {
          this.state.activeYoutube && (
            <div className="youtube_play_box">
              <div className="youtube-close" onClick={() => this.setState({ activeYoutube: "" })}></div>
              <YouTube
                videoId={this.state.activeYoutube}
                className="embed-youtube"
                opts={this.state.opts}
                onReady={this._onReady}
              />
            </div>
          )
        }
      </section>
    );
  }
}

export default TierPerks;
